// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3O5H_","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__uoweL"};